export type StackedBarDatum = { label: string; first: number; repeat: number };

export const KEY_METRICS_FIXTURES: StackedBarDatum[] = [
  { label: "Apr", first: 10, repeat: 2 },
  { label: "May", first: 18, repeat: 4 },
  { label: "Jun", first: 22, repeat: 6 },
  { label: "Jul", first: 28, repeat: 8 },
  { label: "Aug", first: 35, repeat: 10 },
  { label: "Sep", first: 52, repeat: 15 },
  { label: "Oct", first: 58, repeat: 22 },
  { label: "Nov", first: 46, repeat: 30 },
  { label: "Dec", first: 40, repeat: 18 },
  { label: "Jan", first: 48, repeat: 14 },
  { label: "Feb", first: 30, repeat: 10 },
  { label: "Mar", first: 22, repeat: 8 },
];
